import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import Login from '../../react/dealers/login/Login';
import 'dibs-react-tooltip/dist/main.css';

ReactDOM.render(
    <IntlProvider locale="en">
        <Login formType="resetPasswordEmail" />
    </IntlProvider>,
    document.getElementById('login-react-mount-point')
);
